import React from 'react';
// import { useAppDispatch } from '@src/core/hooks';
// import { clearHighlightedProductAdder } from '@src/stores/product';
import PlaneSeatmapRender from '@src/components/SeatMap/PlaneSeatmapRender';
// import { Modal, ModalHeader } from '@planne-software/uni';
// import { Stack } from '@planne-software/uni/mui/material';
// import { track } from '@src/services/analytics';
// import useTranslate from '@src/i18n/useTranslate';
import { useProductSeatmapSelection } from '@src/domains/products/hooks/useProductSeatmapSelection';

const ProductAdderSeatMap = () => {
  // const [isModalOpen, setIsModalOpen] = useState(true);
  // const { i18n } = useTranslate();
  // const dispatch = useAppDispatch();

  const { selectedHour, selectedTariffs, scheduling, selectSeatFromMap } = useProductSeatmapSelection();

  // const handleClose = () => {
  //   track('productAdderClose');

  //   dispatch(clearHighlightedProductAdder());

  //   setIsModalOpen(false);
  // };

  // return (
  //   <Modal open={isModalOpen} onClose={handleClose} sx={(theme) => ({ zIndex: theme.zIndex.modal + 9999 })}>
  //     <Stack
  //       sx={{
  //         height: '100vh',
  //         display: 'flex',
  //         overflow: 'hidden',
  //         flexDirection: 'column',
  //       }}
  //     >
  //       <ModalHeader title={i18n('seatMap_selectSeat')} onClose={handleClose} divider />

  //       <PlaneSeatmapRender
  //         scheduling={scheduling!}
  //         timeMinutes={selectedHour ?? null}
  //         selectedTariffs={selectedTariffs}
  //         onSelectionChange={selectSeatFromMap}
  //       />
  //     </Stack>
  //   </Modal>
  // );

  return (
    <PlaneSeatmapRender
      scheduling={scheduling!}
      timeMinutes={selectedHour}
      selectedTariffs={selectedTariffs}
      onSelectionChange={selectSeatFromMap}
    />
  );
};

export default ProductAdderSeatMap;
